/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid */
import React from "react";
import {Trans} from "react-i18next";
import "./Pagination.scss";
import {getMaxProductCountPerPage, getMinProductCountPerPage} from "../helper/paginationUtil";

                               
                             
                       
                       
                         
                        
                  
                             
 

const Pagination = (props                 ) => {
    return props.totalItems === 0
        ? <span className="pagina">
	<div>
		{props.t("main.noArticleFound")}
	</div>
</span>
        : <span className="pagina" data-testid={"pagniation"}>
	{props.currentPageIndex > 0
        ? <button aria-label={props.currentPageIndex - 1}
                  onClick={() => props.setPage(props.currentPageIndex - 1)}></button>
        : null
    }
	{props.loadingNextPage
                ? (<div className="dot-elastic"></div>)
                : <Trans
                    i18nKey="main.article"
                    values={{
                        min: getMinProductCountPerPage(props),
                        max: getMaxProductCountPerPage(props),
                        productCount: props.totalItems
                    }}
                    components={[<span key="0"/>]}
                />
            }
	{props.currentPageIndex < props.totalPages - 1
                ? <button aria-label={props.currentPageIndex + 1}
                          onClick={() => props.setPage(props.currentPageIndex + 1)}></button>
                : null
            }
</span>;
};

export default Pagination;
